import { Box } from '@mui/material';

import { Button } from '@octopus/ui/design-system';
import { BottomActionBar } from '@octopus/ui/shared-components';

export const FormActionBar = ({
  onSimulate,
  isLoading,
}: {
  onSimulate: () => void;
  isLoading: boolean;
}) => {
  return (
    <BottomActionBar sx={{ justifyContent: 'end', alignItems: 'center' }}>
      <Box display="flex" alignItems="center" gap={2}>
        <Button
          sx={{ minWidth: '150px' }}
          type="submit"
          variantSemantic="primary"
          onClick={onSimulate}
          isLoading={isLoading}
        >
          Gerar simulação
        </Button>
      </Box>
    </BottomActionBar>
  );
};
